// extracted by mini-css-extract-plugin
export var blink = "_8d-2";
export var cursor = "_8d-1";
export var reactMarkdown = "_8d-3";
export var streamingText = "_8d-0";